/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Tone_EnthusiasticInputs */

const en_cover_letters_tone_enthusiastic = /** @type {(inputs: Cover_Letters_Tone_EnthusiasticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enthusiastic`)
};

const de_cover_letters_tone_enthusiastic = /** @type {(inputs: Cover_Letters_Tone_EnthusiasticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enthusiastisch`)
};

const fr_cover_letters_tone_enthusiastic = /** @type {(inputs: Cover_Letters_Tone_EnthusiasticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enthousiaste`)
};

const es_cover_letters_tone_enthusiastic = /** @type {(inputs: Cover_Letters_Tone_EnthusiasticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entusiasta`)
};

const it_cover_letters_tone_enthusiastic = /** @type {(inputs: Cover_Letters_Tone_EnthusiasticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entusiasta`)
};

const nl_cover_letters_tone_enthusiastic = /** @type {(inputs: Cover_Letters_Tone_EnthusiasticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enthousiast`)
};

const pl_cover_letters_tone_enthusiastic = /** @type {(inputs: Cover_Letters_Tone_EnthusiasticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entuzjastyczny`)
};

const fi_cover_letters_tone_enthusiastic = /** @type {(inputs: Cover_Letters_Tone_EnthusiasticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innostunut`)
};

const da_cover_letters_tone_enthusiastic = /** @type {(inputs: Cover_Letters_Tone_EnthusiasticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entusiastisk`)
};

const sv_cover_letters_tone_enthusiastic = /** @type {(inputs: Cover_Letters_Tone_EnthusiasticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entusiastisk`)
};

/**
* | output |
* | --- |
* | "Enthusiastic" |
*
* @param {Cover_Letters_Tone_EnthusiasticInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_tone_enthusiastic = /** @type {((inputs?: Cover_Letters_Tone_EnthusiasticInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Tone_EnthusiasticInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_tone_enthusiastic(inputs)
	if (locale === "fr") return fr_cover_letters_tone_enthusiastic(inputs)
	if (locale === "es") return es_cover_letters_tone_enthusiastic(inputs)
	if (locale === "it") return it_cover_letters_tone_enthusiastic(inputs)
	if (locale === "nl") return nl_cover_letters_tone_enthusiastic(inputs)
	if (locale === "pl") return pl_cover_letters_tone_enthusiastic(inputs)
	if (locale === "fi") return fi_cover_letters_tone_enthusiastic(inputs)
	if (locale === "da") return da_cover_letters_tone_enthusiastic(inputs)
	if (locale === "sv") return sv_cover_letters_tone_enthusiastic(inputs)
	return en_cover_letters_tone_enthusiastic(inputs)
});